export default [
  {
    path: '/reports/scheduled-reports',
    name: 'Scheduled Reports Admin',
    component: () => import('./pages/ScheduledReportsAdmin.vue'),
    meta: { id: 'scheduled-reports' },
  },
];
